import { Component, Vue, PropSync } from 'vue-property-decorator';
import { ConfigurationField } from '@/models/configuration/Field';

@Component
export default class ProcessHeaderItemComponent extends Vue {
    @PropSync('field', { type: Object }) public syncedField!: ConfigurationField;
    public checkboxValue: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {

    }
}
